import ProductLocationFormWithPreview from './ProductLocationFormWithPreview'

export default ProductLocationFormWithPreview
